import React from 'react';
import { useNavigate as useRouterNavigate } from 'react-router';

import { LinkButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { useCard } from '@/react-query/hooks/query/use-card';

import { useNavigate } from '@domain/app';
import useText from '@hooks/use-text';
import { goToRoot } from '@utils/url-utils';
import { getCardQueryKeys } from '@utils/url/get-url-utils';

import './Footer.scss';

interface FooterProps {
    next: () => void;
    canGoBack?: boolean;
    canCancel?: boolean;
    nextText?: string;
    disabled?: boolean;
}

// NOTE: this component is now duplicated for KB, should be removed later

const Footer = ({ next, disabled = false, nextText, canGoBack = false, canCancel = true }: FooterProps) => {
    const { data: card } = useCard();
    const { formNext, formCancel, formBack } = useText();
    const routerNavigate = useRouterNavigate();
    const navigate = useNavigate();

    const cancel = () => {
        if (card) {
            navigate('CARD_PAGE')(getCardQueryKeys(card));
        } else {
            goToRoot(navigate);
        }
    };

    const back = () => routerNavigate(-1);

    return (
        <div className="footer-fixed">
            <div className="footer-button-row">
                {canGoBack && (
                    <StandardButton onClick={back} icon={IconTypes.BACK} size="small">
                        {formBack}
                    </StandardButton>
                )}
                {!canGoBack && canCancel && <LinkButton onClick={cancel}>{formCancel}</LinkButton>}
                <StandardButton onClick={next} disabled={disabled}>
                    {nextText ?? formNext}
                </StandardButton>
            </div>

            {canGoBack && canCancel && <LinkButton onClick={cancel}>{formCancel}</LinkButton>}
        </div>
    );
};

export default Footer;
